import { useEffect, useState } from 'react';
import server from '../../../api/server';
import { isArchived, readWidgetResponse } from './widgetConfiguration';

// The existing list is a summary; chat settings are read from agent details.
// The backend revalidates the newest deployed version at widget save/bootstrap.
export default function useWidgetAgents(context) {
  const [state, setState] = useState({ agents: [], loading: true, error: '' });
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    let cancelled = false;
    setState({ agents: [], loading: true, error: '' });
    const load = async () => {
      try {
        const body = await readWidgetResponse(await server.getAgentsList(context.client_id, '', context.email, 'voice-agents', 'agents'));
        if (!Array.isArray(body.data)) throw new Error('Unable to read routing agents.');
        const summaries = body.data.filter(agent => !isArchived(agent));
        let next = 0; const agents = []; let failed = false;
        await Promise.all(Array.from({ length: Math.min(4, summaries.length) }, async () => {
          while (!cancelled && next < summaries.length) {
            const summary = summaries[next++];
            try {
              const detail = await readWidgetResponse(await server.getAgentDetails(context.client_id, '', context.email, 'voice-agents', 'agents', summary.agent_id));
              if (!detail.data?.agent_id) throw new Error('Missing agent configuration.');
              agents.push({ ...summary, ...detail.data });
            } catch { failed = true; }
          }
        }));
        if (!cancelled) setState({ agents: agents.sort((a, b) => String(a.agent_name || a.agent_id).localeCompare(b.agent_name || b.agent_id)), loading: false, error: failed ? 'Some agent configurations could not be loaded. Retry to see all eligible agents.' : '' });
      } catch (error) {
        if (!cancelled) setState({ agents: [], loading: false, error: error.message || 'Unable to load agents.' });
      }
    };
    load();
    return () => { cancelled = true; };
  }, [context.client_id, context.email, revision]);
  return { ...state, reload: () => setRevision(value => value + 1) };
}
